/* eslint-disable @typescript-eslint/no-unused-vars */
import { createStyles, Button as MantineButton } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';
import { CustomModal } from '../../../components/customModal';
import { Button } from '../../../components/atoms';
import signature from '../../../assets/images/signature.png';
import uploaded from "../../../assets/icons/check.svg";
import close from "../../../assets/icons/cross-circle.svg";

interface IPreviewSignatureModal {
  opened: boolean;
  onClose: () => void;
  imagePreview: any;
  handleDiscardSignatureImage: () => void
  handleSaveSignatureImage: () => void
  uploadButton:any
}

const useModalStyles = createStyles((theme) => ({
  previewImageWrapper: {
    height: 260,
    width: 420,
    margin: "auto",
    padding: 12,
    paddingBottom: 16,
    objectFit: "contain",
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      width: "100%",
    },
  },
  image: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  modalWrapper: {
    width: "100%",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    paddingBottom: 0,
  },
  dummySignature: {
    height: 150,
    width: 420,
    margin: "auto",
    padding: 12,
    paddingBottom: 16,
    paddingTop: 20,
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      width: "100%",
    },
  },
  rules: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
    paddingLeft: 12,
    ...getTypographyStyles("content_sm_medium"),
  },
}));

const signaturePointers = [
  {
    id: 1,
    text: "Sign exactly like as on your PAN Card",
    icon: uploaded,
    color: "text_success_default",
  },
  {
    id: 2,
    text: "Upload signature on straight line",
    icon: uploaded,
    color: "text_success_default",
  },
  {
    id: 3,
    text: "Don’t use ruled or dotted lines",
    icon: close,
    color: "text_error_default",
  },
]

const PreviewSignatureModal = ({
  opened,
  onClose,
  imagePreview,
  handleDiscardSignatureImage,
  handleSaveSignatureImage,
  uploadButton,
}: IPreviewSignatureModal) => {
  const { classes: modalClasses } = useModalStyles();

  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      className={modalClasses.modalWrapper}
      closeOnClickOutside={false}
    >
      {imagePreview ? (
        <>
          <p className="content_md_semibold">Review Signature</p>
          <p className="content_sm_regular text_fg_subtle">Please check and confirm your uploaded signature.</p>
          <div className={modalClasses.previewImageWrapper}>
            {imagePreview && (
            <img
              className={modalClasses.image}
              src={imagePreview}
              alt="signature-preview"
            />
            )}
          </div>
          <div className={modalClasses.footer}>
            {uploadButton("Upload Again", "")}

            <Button
              onClick={handleSaveSignatureImage}
              radius={8}
              variant="filled"
              type="button"
            >
              Next
            </Button>
          </div>
        </>
      ) : (
        <>
          <p className="content_md_semibold">Signature Guidelines</p>
          <div className={modalClasses.dummySignature}>
            <img
              className={modalClasses.image}
              src={signature}
              alt="signature-preview"
            />
          </div>
          <div>
            {
              signaturePointers.map((pointer) => (
                <div key={pointer.id} className={modalClasses.rules}>
                  <img src={pointer.icon} alt="icon" />
                  <p className={pointer.color}>{pointer.text}</p>
                </div>
              ))
            }
          </div>
          <div className={modalClasses.footer}>
            <div />
            {uploadButton("Upload", "primary")}
          </div>
        </>
      )}
    </CustomModal>
  );
};

export default PreviewSignatureModal;
